<template>
    <div class="text-align">
        <div v-show="isLoadPlatform" style="text-align: center !important">
            <div style="margin-top: 15%" class="spinner spinner-md"></div>
            <br />
            <label>{{ $t("AUTHORIZATIONDOCSIGN.loadingPlatforms") }}</label>
        </div>
        <div v-show="isAuthorizedError">
            <div v-show="isAuthorizedError" style="text-align: center !important">
                <div class="alert alert-light-danger" style="margin-top: 10px">
                    <label v-if="!isShowSafe">{{ $t("AUTHORIZATIOND4SIGN.authorizedError") }}  {{ redirectCountdown }}</label>
                    <label v-else>{{ $t("AUTHORIZATIOND4SIGN.SaveError") }}  {{ redirectCountdown }}</label>
                    <br />
                    <label>{{ GetErrorMessage() }}</label>
                </div>
            </div>
        </div>

        <div v-show="isSave">
            <div style="text-align: center !important">
                <div class="alert alert-light-success" style="margin-top: 10px">
                    <label>{{ $t("AUTHORIZATIOND4SIGN.Save") }} {{ redirectCountdown }}</label>
                </div>
            </div>
        </div>

        <div v-show="isAuthorized">
            <div style="text-align: center !important">
                <div class="alert alert-light-success" style="margin-top: 10px">
                    <label>{{ $t("AUTHORIZATIOND4SIGN.authorized") }} {{ redirectCountdown }}</label>
                </div>
            </div>
        </div>

        <div v-show="isWaitingAuthorization" style="text-align: center !important">
            <div>
                <div style="margin-top: 15%" class="spinner spinner-md"></div>
                <br />
                <label v-if="!isShowSafe">{{ $t("AUTHORIZATIOND4SIGN.awaitingAuthorization") }}</label>
                <label v-else>{{ $t("AUTHORIZATIOND4SIGN.awaitingSave") }}</label>
            </div>
        </div>
        <div v-show="!isWaitingAuthorization && !isLoadPlatform && !isAuthorized">
            <div v-show="!isShowSafe" class="p-2">
                <label>{{ $t("AUTHORIZATIOND4SIGN.tokenApi") }}</label>
                <div class="small text-muted mb-2">
                    {{ $t("AUTHORIZATIOND4SIGN.d4SignIntegrationKeyDescription") }}
                    <a target="_blank"
                       href="https://docapi.d4sign.com.br/docs/introdu%C3%A7%C3%A3o-a-api">{{ $t("AUTHORIZATIOND4SIGN.details") }}</a>
                </div>
                <input v-model="platforms.d4SignData.integrationKey"
                       v-on:keypress="platforms.d4SignData.integrationKeyIsErr = false"
                       type="password"
                       class="form-control" />
            </div>
            <div v-show="!isShowSafe" class="p-2">
                <label>{{ $t("AUTHORIZATIOND4SIGN.cryptKey") }}</label>
                <div class="small text-muted mb-2">
                    {{ $t("AUTHORIZATIOND4SIGN.d4SignSecretKeyDescription") }}
                </div>
                <input v-model="platforms.d4SignData.secretKey"
                       v-on:keypress="platforms.d4SignData.secretKeyIsErr = false"
                       type="password"
                       class="form-control" />
            </div>
            <div v-show="!isShowSafe" class="form p-2">
                <button v-on:click="D4SignOnClickAuthorize()"
                        type="button"
                        class="btn btn-primary">
                    {{ $t("AUTHORIZATIOND4SIGN.Authorize") }}
                </button>
            </div>
            <div v-show="isShowSafe && !isSave || isFound" class="p-2">
                <label>{{ $t("AUTHORIZATIOND4SIGN.vault") }}</label>
                <div class="small text-muted mb-2">
                    {{ $t("AUTHORIZATIOND4SIGN.vaultDescription") }}
                </div>
                <select @change="HandleSelectionChange" v-model="safeSelect"
                        class="form-control">
                    <option value="">{{ $t("AUTHORIZATIOND4SIGN.selectOption") }}</option>
                    <option v-for="safe in safeList" :key="safe.uuid_safe" :value="safe.uuid_safe">
                        {{ safe['name-safe'] }}
                    </option>
                </select>
            </div>
            <div v-show="isShowSafe && !isSave" class="form p-2">
                <button v-on:click="D4SignAuthorized()"
                        type="button"
                        class="btn btn-primary">
                    {{ $t("AUTHORIZATIOND4SIGN.SaveSafe") }}
                </button>
            </div>
        </div>
    </div>
</template>


<script>
    import SharedMixin from "./../mixins/SharedMethods.js";
    import PlatformUids from "../shared/platformUids.js";

    export default {
        name: "AuthorizationD4Sign",
        mixins: [SharedMixin],
        props: {
            msg: String,
            language: String,
        },
        data() {
            return {
                platformUids: PlatformUids,
                codeZeev: "",
                isWaitingAuthorization: false,
                isAuthorizingErr: false,
                msgTimeout: 5,
                displayMsgTimeout: 0,
                isAuthorized: false,
                isAuthorizedError: false,
                isShowSafe: false,
                isSave: false,
                redirectCountdown: 5,
                platforms: {
                    list: [],
                    d4SignData: {
                        uId: PlatformUids.D4Sign,
                        name: "",
                        integrationKey: "",
                        integrationKeyIsErr: false,
                        secretKey: "",
                        secretKeyIsErr: false,
                        vault: "",
                        vaultIsErr: false,
                        hrefUriCode: "",
                        code: "",
                        urlRedirect: window.location.host,
                    }
                },
                safeList: [],
                selectedSafeId: '',
                selectedSafeName: '',
                isLoadPlatform: false,
                isFound: false,
                safeSelect: '',
            };
        },
        watch: {
            isAuthorized(newVal) {
                if (newVal) {
                    this.StartCountdown();
                }
            },
            isAuthorizedError(newVal) {
                if (newVal) {
                    this.StartCountdown();
                }
            },
            isSave(newVal) {
                if (newVal) {
                    this.StartCountdown();
                }
            }
        },
        created() {
            var lang = this.$route.params.lang;
            this.setLanguage(lang);
            this.$i18n.locale = lang;
            this.OnLoadAuthorize();
        },
        methods: {
            HandleSelectionChange(event) {
                this.selectedSafeId = event.target.value;
                this.selectedSafeName = event.target.options[event.target.selectedIndex].text;
            },
            GetErrorMessage() {
                return localStorage.getItem("errMsg");
            },
            StartCountdown() {
                const countdownInterval = setInterval(() => {
                    if (this.redirectCountdown > 0) {
                        this.redirectCountdown--;
                    } else {
                        clearInterval(countdownInterval);
                        this.isAuthorized = false;
                        this.isAuthorizedError = false;
                        if (this.isSave) {
                            this.isSave = false;
                        }
                    }
                }, 1000);
            },
            PlatformGetAll: function () {
                let url =
                    this.fullTopUrlWithoutAppCode() +
                    "/internal/v1/authorization/" +
                    this.codeZeev;
                this.isLoadPlatform = true;
                try {
                    this.$http.get(url).then((response) => {
                        this.platforms.list = response.body;

                        var d4SignData = response.body.filter(
                            (platform) => platform.uid == this.platforms.d4SignData.uId
                        );

                        if (d4SignData != undefined) this.D4SignLoadData(d4SignData);
                        this.isLoadPlatform = false;
                    });
                } catch (error) {
                    console.error("Erro ao buscar a lista de plataformas: " + error);
                    this.isLoadPlatform = false;
                }
            },
            D4SignOnClickAuthorize: function () {
                if (!this.D4SignIsDataValid()) return;

                this.redirectCountdown = 5;
                localStorage.removeItem("isD4SignErr");

                this.isWaitingAuthorization = true;

                localStorage.setItem(
                    "integrationKeyD4Sign",
                    this.platforms.d4SignData.integrationKey
                );
                localStorage.setItem(
                    "secretKeyD4Sign",
                    this.platforms.d4SignData.secretKey
                );
                localStorage.setItem(
                    "platformUidD4Sign",
                    this.platforms.d4SignData.uId
                );

                let params = {
                    uid: this.platforms.d4SignData.uId,
                    codeZeev: this.codeZeev,
                    keyApplication: this.platforms.d4SignData.integrationKey,
                    secretKey: this.platforms.d4SignData.secretKey,
                };

                let url = `${this.fullTopUrlWithoutAppCode()}/api/services/v1/d4sign/safe`;
                this.$http.post(url, params).then(
                    (response) => {
                        if (!response.ok) {
                            this.isAuthorizingErr = true;
                            localStorage.setItem("isD4SignErr", true);
                            this.isWaitingAuthorization = false;
                            this.isAuthorizedError = true;
                            localStorage.setItem("errMsg", response.body);                       
                        } else {
                            this.isAuthorizingErr = false;
                            this.isWaitingAuthorization = false;
                            this.isAuthorized = true;
                            localStorage.setItem("isD4SignErr", false);
                            this.safeList = response.body;
                            this.isShowSafe = true;
                        }
                    },
                    (error) => {
                        this.isAuthorizingErr = true;
                        this.isWaitingAuthorization = false;
                        localStorage.setItem("isD4SignErr", true);
                        console.error(error);
                    }
                );
            },
            D4SignIsDataValid() {
                var msg = "";
                if (
                    !this.platforms.d4SignData.integrationKey ||
                    this.platforms.d4SignData.integrationKey.trim().length === 0
                ) {
                    this.platforms.d4SignData.integrationKeyIsErr = true;
                    msg = {
                        type: "danger",
                        text: this.$t("AUTHORIZATIOND4SIGN.validations.D4Sign.integrationKey"),
                    };
                    window.parent.postMessage(msg, "*");
                    return false;
                } else this.platforms.d4SignData.integrationKeyIsErr = false;

                if (
                    !this.platforms.d4SignData.secretKey ||
                    this.platforms.d4SignData.secretKey.trim().length === 0
                ) {
                    this.platforms.d4SignData.secretKeyIsErr = true;
                    msg = {
                        type: "danger",
                        text: this.$t("AUTHORIZATIOND4SIGN.validations.D4Sign.secretKey"),
                    };
                    window.parent.postMessage(msg, "*");
                } else this.platforms.d4SignData.secretKeyIsErr = false;

                if (
                    this.platforms.d4SignData.integrationKeyIsErr ||
                    this.platforms.d4SignData.secretKeyIsErr
                )
                    return false;
                else return true;
            },
            D4SignAuthorized: function () {        
                this.redirectCountdown = 5;
                this.codeZeev = localStorage.getItem("codeZeev");
                var platformUid = localStorage.getItem("platformUidD4Sign");
                localStorage.removeItem("platformUidD4Sign");

                if (this.platforms.d4SignData.uId != platformUid) return;

                this.isWaitingAuthorization = true;

                this.platforms.d4SignData.integrationKey = localStorage.getItem("integrationKeyD4Sign");
                localStorage.removeItem("integrationKeyD4Sign");
                this.platforms.d4SignData.secretKey =
                    localStorage.getItem("secretKeyD4Sign");
                localStorage.removeItem("secretKeyD4Sign");

                let params = {
                    Uid: this.platforms.d4SignData.uId,
                    codeZeev: this.codeZeev,
                    keyApplication: this.platforms.d4SignData.integrationKey,
                    secretKey: this.platforms.d4SignData.secretKey,
                    safeName: this.selectedSafeName,
                    safeId: this.selectedSafeId
                };

                let url = `${this.fullTopUrlWithoutAppCode()}/internal/v1/authorization/d4sign/${platformUid}`;
                this.$http.post(url, params).then(
                    (response) => {
                        if (!response.ok) {
                            this.isAuthorizingErr = true;
                            this.isAuthorizedError = true;
                            localStorage.setItem("isD4SignErr", true);
                            this.isWaitingAuthorization = false;
                            localStorage.setItem("errMsg", response.content);
                        } else if (!response.body.success) {
                            this.isAuthorizedError = true;
                            this.isAuthorizingErr = true;
                            localStorage.setItem("isD4SignErr", true);
                            this.isWaitingAuthorization = false;
                            localStorage.setItem("errMsg", response.body.content);
                        } else {
                            this.isSave = true;
                            this.isAuthorizedError = false;
                            this.isAuthorizingErr = false;
                            this.isWaitingAuthorization = false;
                            localStorage.setItem("isD4SignErr", false);
                            this.isShowSafe = false;
                        }
                    },
                    (error) => {
                        this.isAuthorizingErr = true;
                        this.isWaitingAuthorization = false;
                        localStorage.setItem("isD4SignErr", true);
                        console.error(error);
                    }
                );
            },
            D4SignLoadData: function (d4SignData) {
                var json = JSON.parse(d4SignData[0].json);

                if (json) {
                    this.platforms.d4SignData.url = json.Url;
                    this.platforms.d4SignData.oAuthMethod = json.OAuthMethod;

                    if (json.ClientKey) {
                        this.platforms.d4SignData.integrationKey = json.ClientKey;
                        this.platforms.d4SignData.secretKey = json.SecretKey;
                        const newSafe = {
                            "uuid_safe": json.UuidSafe,
                            "name-safe": json.NameSafe
                        };
                        this.safeList = [];
                        this.safeList.push(newSafe);
                        this.safeSelect = json.UuidSafe;
                        this.isFound = true;
                    }
                }
            },
            OnLoadAuthorize: function () {
                this.codeZeev = this.$route.params.obj;
                if (this.codeZeev == undefined) return;
                localStorage.setItem("codeZeev", this.codeZeev);
                this.PlatformGetAll();
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .text-align {
        text-align: left;
    }
</style>
